import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LibTableComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-pie-table',
  templateUrl: './app-pie-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AppPieTableComponent extends LibTableComponent {
  public options: any;

  override start(): void {
    this.updateTableData();
  }

  override updateTableData() {
    const data = [];
    const chartOptions = this.table?.getCustomAttribute('chartOptions');
    for (let rowIndex = 0; rowIndex < this.visibleRecords?.length; rowIndex++) {
      const { recordData } = this.visibleRecords[rowIndex];
      data.push({ name: recordData[Object.keys(recordData)[0]], value: recordData[Object.keys(recordData)[1]] });
    }
    this.options = {
      tooltip: {
        trigger: 'item'
      },
      ...chartOptions,
      series: [
        {
          type: 'pie',
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 2
          },
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          data,
        },
      ],
    };

  }

}
